module.exports = __webpack_public_path__ + "img/tarj2-4.69bc75c4.svg";